// src/components/Car/CarCard.js

import React from 'react';
import { Link } from 'react-router-dom';
import './CarCard.css';

const CarCard = ({ car }) => {
  return (
    <div className="car-card">
      <Link to={`/cars/${car._id}`}>
        {car.images && car.images.length > 0 ? (
          <img src={car.images[0]} alt={`${car.brand} ${car.model}`} />
        ) : (
          <img src="/path/to/default-image.jpg" alt="Default" />
        )}
        <h3>{car.year} {car.brand} {car.model}</h3>
        <p>{car.description}</p>
        <p>Price: KES {car.price}</p>
      </Link>
    </div>
  );
};

export default CarCard;
